import React, { useState, useEffect } from 'react';
import { Carousel1, Carousel2, Carousel3, Carousel4, DownloadAPPSTOREAPPIcon, DownloadAPPSTOREDarkAPPIcon, DownloadChromeExtensionSTOREAPPIcon, DownloadChromeExtensionSTOREDarkAPPIcon, DownloadMACAPPIcon, DownloadMACDarkAPPIcon, DownloadPLAYSTOREAPPIcon, DownloadPLAYSTOREDarkAPPIcon, DownloadTEAMSSTOREAPPIcon, DownloadTEAMSSTOREDarkAPPIcon, DownloadWinAPPIcon, DownloadWinDarkAPPIcon, FalconLogo } from '../../icon';
import { useSelector } from 'react-redux';
import * as selector from "../../selectors/selectors"
import { Grid, Tooltip } from '@mui/material';
import { ViewTextLabels } from '../shared/constants';
import Config from '../../config';

interface Iprops {
    ParentComponent
}

const Carousel = (Props: Iprops) => {
    const [downloadIconHovered, setDownloadIconHovered] = useState<string>("")
    const IsTeamsApp: boolean = useSelector(selector.isTeamsApp)

    const [activeIndex, setActiveIndex] = useState(0);

    const images = Props.ParentComponent === ViewTextLabels.SIGN_IN ? [
        {
            component:
                <>
                    <div className='w-p-100 h-p-30 d-flex align-center flex-direction justify-center'>
                        <div className='h1-semibold '>Manage your workflow</div>
                        <div className='h5-regular'>Send and receive messages using Toll-Free, Landline,</div>
                        <div className=' h5-regular'> VoIP or MS Teams direct routing number today!</div>
                    </div>
                    <div className='h-p-75 w-p-100'>
                        <Carousel1 className='w-p-100 h-p-100' />
                    </div>
                </>
            , caption: 'sign in image 1'
        },
        {
            component:
                <>
                    <div className='w-p-100 h-p-30 d-flex align-center flex-direction justify-center'>
                        <div className='h1-semibold'>Seamless Application</div>
                        <div className='h1-semibold'> Integration with Microsoft Teams</div>
                        <div className='h5-regular'>Send and receive messages using Toll-Free, Landline,</div>
                        <div className=' h5-regular'> VoIP or MS Teams direct routing number today!</div>
                    </div>
                    <div className='h-p-75 w-p-100'>
                        <Carousel2 className='w-p-100 h-p-100' />
                    </div>
                </>
            , caption: 'sign in image 2'
        },
    ] :
        [
            {
                component:
                    <>
                        <div className='w-p-100 h-p-30 d-flex align-center flex-direction justify-center'>
                            <div className='h1-semibold '>SMS texting solutions</div>
                            <div className='h1-semibold '>for all your business needs</div>
                            <div className='h5-regular'>Transform your marketing,sales,customer service</div>
                            <div className=' h5-regular'> and HR communications with the ultimate texting solution</div>
                        </div>
                        <div className='h-p-75 w-p-100 d-flex justify-center align-center'>
                            <Carousel3 className='h-p-90' />
                        </div>
                    </>
                , caption: 'sign up image 1'
            },
            {
                component:
                    <>
                        <div className='w-p-100 h-p-30 d-flex align-center flex-direction justify-center'>
                            <div className='h1-semibold'>Level Up your</div>
                            <div className='h1-semibold'> text marketing compaigns</div>
                            <div className='h5-regular'>Convert your leads into customers with premium features like</div>
                            <div className=' h5-regular'>templates,group texting,automated replies,dashboards and reports</div>
                        </div>
                        <div className='h-p-75 w-p-100'>
                            <Carousel4 className='w-p-100 h-p-100' />
                        </div>
                    </>
                , caption: 'sign up image 2'
            },
        ];

    useEffect(() => {
        const intervalId = setInterval(() => {
            setActiveIndex((prevIndex) => (prevIndex + 1) % images.length);
        }, 5000);
        return () => clearInterval(intervalId);
    }, [images.length]);

    return (
        <>
            <div className='w-p-100 h-p-10 d-flex align-end pl-8'>
                <FalconLogo className="w-20" />
            </div>
            <div className='d-flex flex-direction align-center w-p-100 h-p-75'>
                {
                    images.map((image, index) => (
                        <React.Fragment key={index}>
                            {index === activeIndex && image.component}
                        </React.Fragment>
                    ))
                }
            </div>
            <div className='w-p-60 min-w-50 h-p-15 min-h-12 max-h-12'>
                {!IsTeamsApp &&
                    <Grid item xs={12} className={` d-flex t-align-center `}>
                        <Grid container >
                            <Grid item xs={12}>
                                <span className='h5-medium color-login-text-field-font'>Get the Falkon SMS App</span>
                            </Grid>
                            <Grid item xs={12} >
                                <Grid container >
                                    <Grid item xs={2} className="d-flex justify-center">
                                        <Tooltip title={ViewTextLabels.DOWNLOAD_WINDOWS_APP} placement='bottom-start' classes={{ popper: "tooltip-z-index" }}>
                                            <a href={Config.WINDOWS_APP_LINK} target="_blank" className="login-app-download-icon" rel="noopener noreferrer" onMouseEnter={() => setDownloadIconHovered("Win")}
                                                onMouseLeave={() => setDownloadIconHovered("")}>
                                                {(downloadIconHovered === "Win") ? <DownloadWinDarkAPPIcon /> : <DownloadWinAPPIcon />}
                                            </a>
                                        </Tooltip>
                                    </Grid>
                                    <Grid item xs={2} className="d-flex justify-center">
                                        <Tooltip title={ViewTextLabels.DOWNLOAD_MACOS_APP} placement='bottom-start' classes={{ popper: "tooltip-z-index" }}>
                                            <a href={Config.MAC_APP_LINK} target="_blank" className="login-app-download-icon" rel="noopener noreferrer" onMouseEnter={() => setDownloadIconHovered("Mac")}
                                                onMouseLeave={() => setDownloadIconHovered("")}>
                                                {(downloadIconHovered === "Mac") ? <DownloadMACDarkAPPIcon /> : <DownloadMACAPPIcon />}
                                            </a>
                                        </Tooltip>
                                    </Grid>
                                    <Grid item xs={2} className="d-flex justify-center">
                                        <Tooltip title={ViewTextLabels.DOWNLOAD_APPSTORE_APP} placement='bottom-start' classes={{ popper: "tooltip-z-index" }}>
                                            <a href={Config.APPSTORE_APP_LINK} target="_blank" className="login-app-download-icon" rel="noopener noreferrer" onMouseEnter={() => setDownloadIconHovered("AppStore")}
                                                onMouseLeave={() => setDownloadIconHovered("")}>
                                                {(downloadIconHovered === "AppStore") ? <DownloadAPPSTOREDarkAPPIcon /> : <DownloadAPPSTOREAPPIcon />}
                                            </a>
                                        </Tooltip>
                                    </Grid>
                                    <Grid item xs={2} className="d-flex justify-center">
                                        <Tooltip title={ViewTextLabels.DOWNLOAD_PAYSTORE_APP} placement='bottom-start' classes={{ popper: "tooltip-z-index" }}>
                                            <a href={Config.PLAYSTORE_APP_LINK} target="_blank" className="login-app-download-icon" rel="noopener noreferrer" onMouseEnter={() => setDownloadIconHovered("PlayStore")}
                                                onMouseLeave={() => setDownloadIconHovered("")}>
                                                {(downloadIconHovered === "PlayStore") ? <DownloadPLAYSTOREDarkAPPIcon /> : <DownloadPLAYSTOREAPPIcon />}
                                            </a>
                                        </Tooltip>
                                    </Grid>
                                    <Grid item xs={2} className="d-flex justify-center">
                                        <Tooltip title={ViewTextLabels.DOWNLOAD_TEAMSSTORE_APP} placement='bottom-start' classes={{ popper: "tooltip-z-index" }}>
                                            <a href={Config.TEAMSSTORE_APP_LINK} target="_blank" className="login-app-download-icon" rel="noopener noreferrer" onMouseEnter={() => setDownloadIconHovered("TeamsStore")}
                                                onMouseLeave={() => setDownloadIconHovered("")}>
                                                {(downloadIconHovered === "TeamsStore") ? <DownloadTEAMSSTOREDarkAPPIcon /> : <DownloadTEAMSSTOREAPPIcon />}
                                            </a>
                                        </Tooltip>
                                    </Grid>
                                    <Grid item xs={2} className="d-flex justify-center">
                                        <Tooltip title={ViewTextLabels.DOWNLOAD_CHROMESTORE_APP} placement='bottom-start' classes={{ popper: "tooltip-z-index" }}>
                                            <a href={Config.CHROMESTORE_APP_LINK} target="_blank" className="login-app-download-icon" rel="noopener noreferrer" onMouseEnter={() => setDownloadIconHovered("ChromeExtStore")}
                                                onMouseLeave={() => setDownloadIconHovered("")}>
                                                {(downloadIconHovered === "ChromeExtStore") ? <DownloadChromeExtensionSTOREDarkAPPIcon /> : <DownloadChromeExtensionSTOREAPPIcon />}
                                            </a>
                                        </Tooltip>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                }
            </div>
        </>
    );
};

export default Carousel;